import { useRef } from 'react';

import { AreaChart, type AreaData, useChartTheme } from '../../../index';
import { ReplotChartNames } from '../../constants';
import { type CommonPlotProps, FormatType } from '../../types';
import { plotTestId } from '../../utilities/plotTestId';
import styles from './kde-chart.module.css';

type KdeValue = {
  value: number;
  kde: number;
  cdf: number;
};

export type KdeData = {
  label: string;
  color?: string;
  values: KdeValue[];
};

type KdeChartProps = {
  data: KdeData[];
  colors?: string[];
} & CommonPlotProps;

/**
 * Kernel Density Estimate chart
 * @deprecated Use AreaChart instead
 */
export const KdeChart = ({
  data,
  colors: colorsProp,
  format = FormatType.SI,
  loading = false,
  renderUpdate,
  currencyCode,
}: KdeChartProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { palette } = useChartTheme();
  const colors = colorsProp ?? palette;
  const areaData: AreaData[] = data.map((d) => ({
    label: d.label,
    values: d.values.map((v) => ({
      x: v.value,
      value: v.kde,
      secondaryValue: v.cdf,
    })),
  }));

  const colorArr = data.map((d, i) => d.color || colors[i % colors.length]);

  return (
    <div
      ref={containerRef}
      className={styles.container}
      data-testid={plotTestId(ReplotChartNames.KDE)}
    >
      <AreaChart
        data={areaData}
        // @ts-ignore noUncheckedIndexedAccess
        colors={colorArr}
        format={format}
        loading={loading}
        renderUpdate={renderUpdate}
        currencyCode={currencyCode}
        showYAxis={false}
      />
    </div>
  );
};
